export const societyPricesPreconfig = {
    config1: {
        km_price: 0.4,
        reservation_price: 1.5,
        hour_price_list: [2.7, 2.7, 2.7, 2.7, 2.7, 2.7, 1],
        block_list: [{
            amount: 2.7,
            start: "0:00:00",
            end: "8:00:00"
        }, {
            amount: 2.7,
            start: "8:00:00",
            end: "12:00:00"
        }, {
            amount: 2.7,
            start: "12:00:00",
            end: "16:00:00"
        }, {
            amount: 2.7,
            start: "16:00:00",
            end: "24:00:00"
        }],
        discount_list: [],
        price_type: 'hour_prices',
        limited_hour_day: 10,
        fuel_included: 1
    },
    config1_old: {
        kmPrice: 0.4,
        reservationPrice: 1.5,
        hourPrices: [2.7, 2.7, 2.7, 2.7, 2.7, 2.7, 1],
        blocks: [{
            amount: 2.7,
            start: "0:00:00",
            end: "8:00:00"
        }, {
            amount: 2.7,
            start: "8:00:00",
            end: "12:00:00"
        }, {
            amount: 2.7,
            start: "12:00:00",
            end: "16:00:00"
        }, {
            amount: 2.7,
            start: "16:00:00",
            end: "24:00:00"
        }],
        discounts: [],
        priceType: 'hour_prices',
        limitHourPerDay: 10,
        fuelIncluded: 1
    },
    config2: {
        km_price: 0.4,
        reservation_price: 1.5,
        hour_price_list: [2.7, 2.7, 2.7, 2.7, 2.7, 2.7, 1],
        block_list: [{
            amount: 2.7,
            start: 0,
            end: 8
        }, {
            amount: 2.7,
            start: 8,
            end: 12
        }, {
            amount: 2.7,
            start: 12,
            end: 16
        }, {
            amount: 2.7,
            start: 16,
            end: 24
        }],
        discount_list: [],
        price_type: 'hour_prices',
        limited_hour_day: 10,
        fuel_included: 1
    },
    config_clean: {
        km_price: 0,
        reservation_price: 0,
        hour_price_list: [0, 0, 0, 0, 0, 0, 0],
        block_list: [{
            amount: 0,
            start: 0,
            end: 8
        }, {
            amount: 0,
            start: 8,
            end: 12
        }, {
            amount: 0,
            start: 12,
            end: 16
        }, {
            amount: 0,
            start: 16,
            end: 24
        }],
        discount_list: [],
        price_type: 'hour_prices',
        limited_hour_day: 0,
        fuel_included: 1
    },
    config2_old: {
        kmPrice: 0.4,
        reservationPrice: 1.5,
        hourPrices: [2.7, 2.7, 2.7, 2.7, 2.7, 2.7, 1],
        blocks: [{
            amount: 2.7,
            start: 0,
            end: 8
        }, {
            amount: 2.7,
            start: 8,
            end: 12
        }, {
            amount: 2.7,
            start: 12,
            end: 16
        }, {
            amount: 2.7,
            start: 16,
            end: 24
        }],
        discounts: [],
        priceType: 'hour_prices',
        limitHourPerDay: 10,
        fuelIncluded: 1
    }
}